/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Point system display configuration
 * @export
 * @interface SurfacePointSystemConfig
 */
export interface SurfacePointSystemConfig {
    /**
     * Use this surface's own points (true) or DevourPlay XP (false)
     * @type {boolean}
     * @memberof SurfacePointSystemConfig
     */
    useCustomPoints?: boolean;
    /**
     * Custom points name (e.g., "Beast Points", "Snapple XP")
     * @type {string}
     * @memberof SurfacePointSystemConfig
     */
    pointsName?: string;
    /**
     * Asset id backing the icon. Echoed so an editor can tell an icon apart from none.
     * @type {string}
     * @memberof SurfacePointSystemConfig
     */
    pointsIconId?: string;
    /**
     * Custom points icon URL
     * @type {string}
     * @memberof SurfacePointSystemConfig
     */
    pointsIconUrl?: string;
}

/**
 * Check if a given object implements the SurfacePointSystemConfig interface.
 */
export function instanceOfSurfacePointSystemConfig(value: object): value is SurfacePointSystemConfig {
    return true;
}

export function SurfacePointSystemConfigFromJSON(json: any): SurfacePointSystemConfig {
    return SurfacePointSystemConfigFromJSONTyped(json, false);
}

export function SurfacePointSystemConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePointSystemConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'useCustomPoints': json['useCustomPoints'] == null ? undefined : json['useCustomPoints'],
        'pointsName': json['pointsName'] == null ? undefined : json['pointsName'],
        'pointsIconId': json['pointsIconId'] == null ? undefined : json['pointsIconId'],
        'pointsIconUrl': json['pointsIconUrl'] == null ? undefined : json['pointsIconUrl'],
    };
}

export function SurfacePointSystemConfigToJSON(json: any): SurfacePointSystemConfig {
    return SurfacePointSystemConfigToJSONTyped(json, false);
}

export function SurfacePointSystemConfigToJSONTyped(value?: SurfacePointSystemConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'useCustomPoints': value['useCustomPoints'],
        'pointsName': value['pointsName'],
        'pointsIconId': value['pointsIconId'],
        'pointsIconUrl': value['pointsIconUrl'],
    };
}

